import { getAttestationsRoot } from '../../../store/rootSelector';
import { ApplicationState } from '../../../store/types';
import { ColumnSort, TableFilters } from '../../shared/table/types';
import { UserAttestationInstanceDB, UserAttestationInstance } from './types';

export const getAllUserAttestationInstances = (state: ApplicationState): UserAttestationInstanceDB[] => getAttestationsRoot(state).attestationInstances;

export const getCompletedTableView = (state: ApplicationState): boolean => getAttestationsRoot(state).completed;

export const getIsLoading = (state: ApplicationState): boolean => getAttestationsRoot(state).isLoading;

export const getSelectedUserAttestationInstance = (state: ApplicationState): UserAttestationInstance | null => getAttestationsRoot(state).selectedUserAttestationInstance;

export const getUserAttestationInstanceModalOpen = (state: ApplicationState): boolean => getAttestationsRoot(state).userAttestationInstanceModalOpen;

export const getUserAttestationUpdated = (state: ApplicationState): boolean => getAttestationsRoot(state).attestationUpdated;

export const getAlertModalOpen = (state: ApplicationState): string | null => getAttestationsRoot(state).alertModalOpen;

// Table Filters and Pagination
export const getAttestationsPageNumber = (state: ApplicationState): number => getAttestationsRoot(state).attestationPage;
export const getTotalAttestations = (state: ApplicationState): number => getAttestationsRoot(state).totalAttestations;
export const getAttestationFilters = (state: ApplicationState): TableFilters => getAttestationsRoot(state).attestationFilters;
export const getAttestationColumnSort = (state: ApplicationState): ColumnSort | undefined => getAttestationsRoot(state).attestationSort;
export const getAttestationsPageSize = (state: ApplicationState): number => getAttestationsRoot(state).attestationPageSize;
